import { CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import CurrencyConverter from "@/components/CustomUI/modules/CurrencyConverter";
import Stars from "@/components/CustomUI/modules/Stars";
import { gtSectraMedium } from "@/app/jewellery/font";

const Content = ({ rating, name, price, mrp, description, }) => {
  const desc_new = description?.replaceAll("-", " ") || "";
  return (
    <CardContent className="p-0">
      <Stars
        totalRating={rating?.bestRating}
        ratingValue={rating?.ratingValue}
        uniqueKey={"catalog_stars"}
        starClasses="w-[11px] h-[11px] desktop:w-[18px] desktop:h-[18px]"
      />
      <div className="flex justify-between items-center">
        <CardTitle
          className={`
            truncate text-xs 
            md:text-[1rem] 
            text-font-primary 
            capitalize sm:text-sm desktop:text-base
            ${gtSectraMedium.className}
          `}
        >
          {name}
        </CardTitle>
        <CardDescription
          className="
            font-semibold text-font-primary 
            text-[0.7rem] sm:text-[0.8rem]
            desktop:text-sm
          "
        >
          <CurrencyConverter amount={price} />
        </CardDescription>
      </div>

      <div className="flex justify-between items-center">
        <CardDescription
          className="
            truncate text-font-primary text-[0.6rem] 
            sm:text-[0.8rem] desktop:text-sm
          "
        >
          {desc_new}
        </CardDescription>

        <div className="block md:hidden" />

        {price !== mrp && (
          <CardDescription
            className="
              pl-1 line-through font-semibold 
              text-font-primary text-[0.65rem] 
              sm:text-[0.72rem] desktop:text-sm
            "
          >
            <CurrencyConverter amount={mrp} />
          </CardDescription>
        )}
      </div>
    </CardContent>
  );
};

export default Content;
